export function getHeaders() {
  return useRequestHeaders(["cookie"]);
}
